var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"htmldiv pt25 pb25 clearfix"},[_c('router-view'),_c('TrainSideBar')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"college-bg prelative"},[_c('img',{staticClass:"prelative dblock",attrs:{"src":require("@/assets/images/jm_no_bg.jpg")}})])
}]

export { render, staticRenderFns }